import { ROUTES } from '../../constants/routes';
import { ACCESS } from '../../constants/authz';

/**
 * @typedef {import('./navigation.constants.js').NavItem} NavItem
 */

/**
 * @param {{ isNotProduction?: boolean }} [options]
 * @returns {NavItem[]}
 */
export function buildMenuConfig(options = {}) {
  const { isNotProduction = process.env.REACT_APP_NODE_ENV !== 'production' } = options;

  return [
    {
      title: 'Dashboard',
      iconKey: 'dashboard',
      key: 'dashboard',
      route: ROUTES.DASHBOARD.HUB,
      access: ACCESS.PUBLIC_AUTHENTICATED,
    },
    {
      title: 'Business Service Planning',
      iconKey: 'campaign',
      key: 'campaignPlanning',
      accessKey: 'campaignPlanning',
      children: [
        {
          label: 'Static',
          key: 'static',
          children: [
            {
              label: 'Business Service Decision Board',
              route: ROUTES.CAMPAIGN.DECISION_BOARD,
              accessKey: 'campaignPlanning',
            },
            {
              label: 'List Of Business Service',
              route: ROUTES.CAMPAIGN.LIST,
              accessKey: 'campaignPlanning',
            },
            ...(isNotProduction
              ? [
                { label: 'Booking Plan', route: '/#/HDFHDF0789/releasePlan', accessKey: 'campaignPlanning' },
                { label: 'Suspense Lead Sheet', route: '/#/SuspenseLeadSheet', accessKey: 'campaignPlanning' },
              ]
              : []),
          ],
        },
        {
          label: 'Dynamic',
          key: 'dynamic',
          children: [
            {
              label: 'Supplier',
              key: 'supplier',
              accessKey: 'supplier',
              children: [
                { label: 'Standard Templates', route: ROUTES.LEGACY.SUPPLIER_BASE_TYPE, accessKey: 'supplier' },
                { label: 'Manage Supplier Type', route: ROUTES.LEGACY.SUPPLIER_TYPE, accessKey: 'supplier' },
                { label: 'Manage Supplier', route: ROUTES.LEGACY.SUPPLIER_LIST, accessKey: 'supplier' },
              ],
            },
            {
              label: 'Inventory',
              key: 'inventory',
              accessKey: 'inventory',
              children: [
                { label: 'Standard Template', route: ROUTES.LEGACY.INVENTORY_BASE, accessKey: 'inventory' },
                { label: 'Manage Inventory', route: ROUTES.LEGACY.INVENTORY_LIST, accessKey: 'inventory' },
              ],
            },
            {
              label: 'Booking Engine',
              key: 'bookingEngine',
              accessKey: 'bookingEngine',
              children: [
                { label: 'Standard Templates', route: ROUTES.LEGACY.BOOKING_BASE, accessKey: 'bookingEngine' },
                { label: 'Booking Templates', route: ROUTES.LEGACY.BOOKING_TEMPLATE, accessKey: 'bookingEngine' },
                { label: 'Manage Bookings', route: ROUTES.LEGACY.BOOKING_CAMPAIGNS, accessKey: 'bookingEngine' },
              ],
            },
          ],
        },
      ],
    },
    {
      title: 'Business Service Execution',
      iconKey: 'checklist',
      key: 'campaignExecution',
      accessKey: 'campaignExecution',
      children: [
        {
          label: 'Business Service Checklist',
          route: ROUTES.CAMPAIGN.CHECKLIST,
          accessKey: 'campaignExecution',
        },
      ],
    },
    {
      title: 'Records',
      iconKey: 'howToReg',
      key: 'leads',
      route: ROUTES.LEGACY.RECORDS,
      accessKey: 'leads',
    },
    // {
    //   title: 'Reporting',
    //   iconKey: 'assessment',
    //   key: 'reporting',
    //   accessKey: 'reporting',
    //   route: ROUTES.LEGACY.REPORTING,
    // },
    {
      title: 'Analytics',
      iconKey: 'analytics',
      key: 'analytics',
      accessKey: 'reporting',
      route: ROUTES.FEATURES.ANALYTICS,
    },
    {
      title: 'Management',
      iconKey: 'people',
      key: 'management',
      accessKey: 'management',
      children: [
        {
          label: 'Organization',
          key: 'organization',
          iconKey: 'hub',
          accessKey: 'organization',
          children: [
            { label: 'View', route: ROUTES.MANAGEMENT.ORGANISATION_LIST, accessKey: 'organization' },
            { label: 'On Boarding', route: ROUTES.MANAGEMENT.ORGANISATION_ONBOARD, accessKey: 'organization' },
            { label: 'Organisation Onboarding', route: ROUTES.MANAGEMENT.ORGANISATION_ONBOARDING, accessKey: 'organization' },
            { label: 'Organizations Mapping', route: ROUTES.MANAGEMENT.ORGANISATION_MAPPING, accessKey: 'organization' },
            { label: 'Update Address', route: ROUTES.MANAGEMENT.UPDATE_ADDRESS, accessKey: 'organization' },
            { label: 'Update GST', route: ROUTES.MANAGEMENT.UPDATE_GST, accessKey: 'organization' },
          ],
        },
        {
          label: 'Profile',
          iconKey: 'accountCircle',
          key: 'profileManagement',
          route: ROUTES.MANAGEMENT.PROFILE_MANAGEMENT,
          accessKey: 'profileManagement',
        },
        {
          label: 'License Management',
          iconKey: 'assessment',
          key: 'licenseManagement',
          route: ROUTES.MANAGEMENT.LICENSE,
          accessKey: 'licenseManagement',
        },
        {
          label: 'Users',
          key: 'users',
          iconKey: 'people',
          route: ROUTES.MANAGEMENT.USER_MANAGEMENT,
          accessKey: 'userList',
        },
      ],
    },
    {
      title: 'Intervene',
      iconKey: 'intervene',
      key: 'intervene',
      accessKey: 'intervene',
      route: ROUTES.FEATURES.INTERVENE,
    },
    {
      title: 'Web Form',
      iconKey: 'web',
      key: 'webForm',
      accessKey: 'webForm',
      children: [
        { label: 'B2B2C Form', route: ROUTES.FEATURES.LEAD_WEB_FORM, accessKey: 'webForm' },
        { label: 'B2B Form', route: ROUTES.FEATURES.OPS_VERIFY, accessKey: 'webForm' },
      ],
    },
    {
      title: 'Whatsapp',
      iconKey: 'whatsapp',
      key: 'templates',
      accessKey: 'templates',
      children: [
        {
          label: 'Templates',
          route: ROUTES.FEATURES.WHATSAPP_TEMPLATES,
          accessKey: 'templates',
        },
        {
          label: 'WABA App List',
          route: ROUTES.FEATURES.WHATSAPP_WABA_APPS,
          accessKey: 'wabaAppList',
        },
      ],
    },
    {
      title: 'Template Queue',
      iconKey: 'queue',
      key: 'templateQueue',
      route: ROUTES.FEATURES.WHATSAPP_TEMPLATE_QUEUE,
      access: ACCESS.SUPER_ADMIN_ONLY,
    },
    {
      title: 'Flow Builder',
      iconKey: 'accountTree',
      key: 'flowBuilder',
      accessKey: 'flowBuilder',
      route: ROUTES.FEATURES.FLOW_LIST,
    },
    {
      title: 'SMS',
      iconKey: 'message',
      key: 'sms',
      accessKey: 'sms',
      children: [
        {
          label: 'Templates',
          key: 'smsTemplates',
          route: ROUTES.FEATURES.SMS_LIST,
          accessKey: 'smsTemplates',
        },
        {
          label: 'Logs',
          key: 'smsLog',
          route: ROUTES.FEATURES.SMS_LOGS,
          accessKey: 'smsLog',
        },
      ],
    },
    {
      title: 'E-Commerce',
      iconKey: 'store',
      key: 'ecommerce',
      accessKey: 'ecommerce',
      children: [
        { label: 'Orders', route: ROUTES.LEGACY.ECOMMERCE_ORDERS, accessKey: 'ecommerce' },
        { label: 'Product List', route: ROUTES.LEGACY.ECOMMERCE_LISTING, accessKey: 'ecommerce' },
        { label: 'E-commerce Flow', route: ROUTES.LEGACY.ECOMMERCE_FLOW, accessKey: 'ecommerce' },
      ],
    },
    {
      title: 'AI',
      iconKey: 'smartToy',
      key: 'ai',
      accessKey: 'ai',
      route: ROUTES.LEGACY.AI,
    },
    {
      title: 'Vector Database',
      iconKey: 'hub',
      key: 'vectorDatabase',
      accessKey: 'vectorDatabase',
      route: ROUTES.LEGACY.VECTOR,
    },
    {
      title: 'Dataset',
      iconKey: 'map',
      key: 'entity',
      accessKey: 'entity',
      route: ROUTES.FEATURES.DATASETS,
    },
    {
      type: 'header',
      title: 'Tests & Assessments',
    },
    {
      title: 'Tools',
      iconKey: 'dataObject',
      key: 'tools',
      accessKey: 'tools',
      route: ROUTES.LEGACY.TOOLS,
    },
    {
      title: 'Machadalo Studio',
      iconKey: 'autoAwesome',
      key: 'machadaloStudio',
      accessKey: 'machadaloStudio',
      route: ROUTES.LEGACY.MACHADALO_STUDIO,
    },
    {
      title: 'Concept Builder',
      iconKey: 'school',
      key: 'conceptBuilder',
      accessKey: 'conceptBuilder',
    },
    {
      title: 'Practice Test',
      iconKey: 'quiz',
      key: 'practiceTest',
      accessKey: 'practiceTest',
      route: ROUTES.LEGACY.STUDENT_CREATE_TEST,
    },
    {
      title: 'Knowledge Map',
      iconKey: 'autoStories',
      key: 'knowledgeMap',
      accessKey: 'knowledgeMap',
      route: ROUTES.LEGACY.STUDENT_KNOWLEDGE_MAP,
    },
    {
      title: 'Syllabus Builder',
      iconKey: 'menuBook',
      key: 'syllabusBuilder',
      accessKey: 'syllabusBuilder',
      route: ROUTES.LEGACY.STUDENT_PLATFORM,
    },
    {
      title: 'Performance Map',
      iconKey: 'timeline',
      key: 'performanceMap',
      accessKey: 'performanceMap',
      route: ROUTES.LEGACY.STUDENT_PERFORMANCE,
    },
    {
      title: 'Parent Dashboard',
      iconKey: 'familyRestroom',
      key: 'parentDashboard',
      accessKey: 'parentDashboard',
      route: ROUTES.DASHBOARD.PARENT,
    },
    {
      title: 'Teacher Dashboard',
      iconKey: 'personPin',
      key: 'teacherDashboard',
      accessKey: 'teacherDashboard',
      route: ROUTES.DASHBOARD.TEACHER,
    },
    {
      title: 'Academic Info',
      iconKey: 'infoOutlined',
      key: 'academicDashboard',
      accessKey: 'academicDashboard',
      route: ROUTES.LEGACY.STUDENT_NOTICES,
    },
    {
      title: 'Question Bank',
      iconKey: 'localLibrary',
      key: 'questionbank',
      accessKey: 'questionbank',
      route: ROUTES.LEGACY.STUDENT_QUESTION_BANK,
    },
  ];
}
